import React, { useEffect, useState } from 'react';
import { Input, Modal } from 'antd';
import { REJECT_REASONS, REJECT_TEXT_MAX, validateReject } from './review-rules';

interface Props {
  open: boolean;
  /** Tiêu đề hộp, ví dụ "Từ chối yêu cầu mở nhận donate". */
  title: string;
  onCancel: () => void;
  /** Gửi lên máy chủ. Ném lỗi thì hộp vẫn mở để admin sửa. */
  onSubmit: (reasonCode: string, reasonText: string) => Promise<void> | void;
}

/** Hộp từ chối dùng chung cho yêu cầu mở donate và tích xanh creator. */
const RejectReasonDialog = ({ open, title, onCancel, onSubmit }: Props) => {
  const [code, setCode] = useState('');
  const [text, setText] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setCode('');
      setText('');
      setError(null);
      setBusy(false);
    }
  }, [open]);

  const submit = async () => {
    const err = validateReject(code, text);
    setError(err);
    if (err) return;
    setBusy(true);
    try {
      await onSubmit(code, text.trim());
    } catch {
      // Trang gọi tự báo lỗi máy chủ, hộp giữ nguyên để admin thử lại.
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      onOk={submit}
      okText="Từ chối"
      cancelText="Huỷ"
      okButtonProps={{ danger: true, loading: busy }}
      destroyOnClose
    >
      <div className="flex flex-col gap-3">
        <label className="flex flex-col gap-1 text-sm">
          <span className="font-medium">Lý do từ chối</span>
          <select
            aria-label="Lý do từ chối"
            className="rounded-md border border-slate-300 bg-white px-2 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-800 dark:text-white"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError(null);
            }}
          >
            <option value="" disabled>
              Chọn lý do
            </option>
            {REJECT_REASONS.map((r) => (
              <option key={r.code} value={r.code}>
                {r.label}
              </option>
            ))}
          </select>
        </label>
        <label className="flex flex-col gap-1 text-sm">
          <span className="font-medium">
            Ghi thêm{code === 'other' ? '' : ', không bắt buộc'}
          </span>
          <Input.TextArea
            aria-label="Ghi thêm"
            rows={3}
            maxLength={REJECT_TEXT_MAX}
            showCount
            value={text}
            onChange={(e) => {
              setText(e.target.value);
              setError(null);
            }}
            placeholder="Người dùng sẽ thấy phần này cùng lý do đã chọn"
          />
        </label>
        {error && (
          <p role="alert" className="text-sm text-red-600">
            {error}
          </p>
        )}
      </div>
    </Modal>
  );
};

export default RejectReasonDialog;
